// Central test IDs for QA / Playwright targeting.
export const TID = {
  loader: "kx-loader",
  loaderMandala: "kx-loader-mandala",
  nav: "kx-nav",
  navHome: "nav-link-home",
  navReleases: "nav-link-releases",
  navLyrics: "nav-link-lyrics",
  navAbout: "nav-link-about",
  navPress: "nav-link-press",
  navLicensing: "nav-link-licensing",
  navContact: "nav-link-contact",
  navSupport: "nav-link-support",
  navMenuOpen: "nav-menu-open",
  navMenuClose: "nav-menu-close",
  heroCtaExperience: "hero-cta-experience",
  heroCtaLibrary: "hero-cta-library",
  socialSpotify: "social-spotify",
  socialApple: "social-apple",
  socialYoutube: "social-youtube",
  socialInstagram: "social-instagram",
  socialFacebook: "social-facebook",
  releaseCard: "release-card",
  releaseSpotify: "release-spotify",
  releaseYoutube: "release-youtube",
  releaseApple: "release-apple",
  lyricCard: "lyric-card",
  lyricReaderTabSanskrit: "lyric-tab-sanskrit",
  lyricReaderTabHindi: "lyric-tab-hindi",
  lyricReaderTabEnglish: "lyric-tab-english",
  ambientToggle: "ambient-audio-toggle",
  newsletterEmail: "newsletter-email",
  newsletterSubmit: "newsletter-submit",
  contactName: "contact-name",
  contactEmail: "contact-email",
  contactSubject: "contact-subject",
  contactMessage: "contact-message",
  contactKind: "contact-kind",
  contactSubmit: "contact-submit",
  licensingName: "licensing-name",
  licensingEmail: "licensing-email",
  licensingSubject: "licensing-subject",
  licensingMessage: "licensing-message",
  licensingSubmit: "licensing-submit",
  supportSpotify: "support-spotify",
  supportYoutube: "support-youtube",
  supportInstagram: "support-instagram",
  adminEmail: "admin-email",
  adminPassword: "admin-password",
  adminLoginSubmit: "admin-login-submit",
  adminLogout: "admin-logout",
  adminTabSummary: "admin-tab-summary",
  adminTabSubscribers: "admin-tab-subscribers",
  adminTabContacts: "admin-tab-contacts",
};
